const PREFIX = '/v1/CollectiveProject/CollectiveProjectService'

export const URL = {
  ADD: PREFIX + '/add',
  DEL: PREFIX + '/delete',
  EDIT: PREFIX + '/edit',
  LIST: PREFIX + '/list',
  SIMPLE_LIST: PREFIX + '/listSimple',
  DETAIL: PREFIX + '/view',
  ENABLE: PREFIX + '/able',
  DISABLE: PREFIX + '/disable',
  ORDER: PREFIX + '/order',
  EXPORT: PREFIX + '/export',
  TONGJI: PREFIX + '/tongji',
  ALL_DETAIL: PREFIX + '/viewAll',
  DATA_LIST: PREFIX + '/listData',
  PROCESS_SET: PREFIX + '/status',
  COMP_STANDARD_SET: PREFIX + '/chaiqianbuchangbiaozhun',
  RESETTLE_STANDARD_SET: PREFIX + '/renyuananzhibiaozhun',
  VILLAGE_LIST: PREFIX + '/getProjectVillages',
  HOUSE_BIND: PREFIX + '/bindCommunityHouse',
  HOUSE_LIST: PREFIX + '/getCommunityHouse',
  SS_TPL: PREFIX + '/shebaoImportTemplete',
  SS_IMPORT: PREFIX + '/shebaoImport',
  SS_RECORD_LIST: PREFIX + '/shebaoImportRecordList',
  SS_RECORD_RECOVER: PREFIX + '/shebaoTrash',
  RESETTLE_STANDARD_DETAIL: PREFIX + '/getStandard',
  RESETTLE_STANDARD_SAVE: PREFIX + '/saveStandard'
}
